import { Component, Inject, OnInit } from '@angular/core';

import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Paginacao } from "@app/models/util/paginacao";


import { NaturezaDeAcaoService } from '@app/services/natureza-de-acao.service';
import { NaturezaDeAcaoPesquisa } from '@app/models/natureza-de-acao.model';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-natureza-de-acao-lista',
  templateUrl: './natureza-de-acao-lista.component.html'
})
export class NaturezaDeAcaoListaComponent implements OnInit {

  bsModalRef: BsModalRef;
  filtroDescricao: string = "";
  paginacao: Paginacao = new Paginacao();
  lstNaturezaDeAcao: NaturezaDeAcaoPesquisa[] = [];

  constructor(
    @Inject(ToastrService) public toastr: ToastrService,
    private naturezaDeAcaoService: NaturezaDeAcaoService,
    private modalService: BsModalService) { }

  ngOnInit() {
    this.obterTodos(this.filtroDescricao, 1);
  }

  pesquisar() {
    this.obterTodos(this.filtroDescricao, 1);
    this.paginacao.paginaAtual = 1;
  }

  obterTodos(descricao: string, pagina: number) {
    this.naturezaDeAcaoService.obterLista(descricao, pagina).toPromise().then(data => {
      this.lstNaturezaDeAcao = data.Dados,
        this.paginacao.totalDeItens = data.Total
    }, erro => {
      //this.loading = false;
      this.toastr.warning("Realize a pesquisa novamente.")
    });
  }

  deletar(naturezaDeAcao: NaturezaDeAcaoPesquisa) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = "Deseja realmente excluir a natureza de ação: " + naturezaDeAcao.Descricao + "?";
    this.bsModalRef.content.confirmar = () => {
      this.naturezaDeAcaoService.deletar(naturezaDeAcao.Id).toPromise().then(() => {
        this.obterTodos(this.filtroDescricao, 1);
        this.paginacao.paginaAtual = 1;
      });
    }
  }

  public pageChanged(event: any): void {
    this.obterTodos(this.filtroDescricao, event.page);
  }

}
